import { ProductTypes } from "../../lib/product-types.js";

export default class WizardCheck {
    // _temporarily_ - Temporarily disabling checks - not limiting users
    // ... Uses for fullfilled
    static MultipleCheck(vars, _temporarily_ = true) {
        if (_temporarily_) {
            return true;
        }

        for (const varName in vars) {
            if (WizardCheck[varName] && !WizardCheck[varName](vars[varName])) {
                return false;
            }
        }

        return true;
    }

    /* By Field names */
    static ProductType(value) {
        const PTValues = ProductTypes.map(({ value }) => value);
        return value && PTValues.includes(value);
    }

    static ProductName(value) {
        return this._string(value);
    }

    static ProductDescription(value) {
        return this._string(value);
    }

    static Stimulus(value) {
        return this._string(value);
    }

    static ProductPicture(value) {
        return value && Array.isArray(value) && value.filter(item => !item).length === 0;
    }

    static Actions(value) {
        return !!value;
    }

    static Features(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !this._string(item?.header) || //
                    !this._string(item?.text) //
            ).length === 0
        );
    }

    static Slider(value) {
        return value && Array.isArray(value) && value.filter(item => !item?.image).length === 0;
    }

    static Steps(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !this._string(item?.header) || //
                    !this._string(item?.text) //
            ).length === 0
        );
    }

    static Numbers(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !item?.unit || // unit
                    !this._number(item?.number) || //
                    !this._string(item?.text) //
            ).length === 0
        );
    }

    static PaymentType(value) {
        return !!value;
    }

    static Offers(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !this._string(item?.title) || //
                    !this._cost(item?.cost) || //
                    !this._string(item?.currency) || //
                    !this._string(item?.button) || // buttonText
                    !this._string(item?.buttonLink) || //
                    !this._string(item?.description) || //
                    !this._string(item?.features) //
            ).length === 0
        );
    }

    static Feedbacks(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !this._string(item?.name) || //
                    !this._string(item?.feedback) //
            ).length === 0
        );
    }

    static GetInTouch(value) {
        return (
            value &&
            this._string(value?.text) && //
            this._email(value?.email) && //
            this._string(value?.button) //
        );
    }

    static Legacy(value) {
        return (
            value &&
            Array.isArray(value) &&
            value.filter(
                item =>
                    !this._string(item?.title) || //
                    !this._string(item?.text) //
            ).length === 0
        );
    }

    /* Helpers -------------------------------------------------------------- */
    static _isObject(value) {
        return value && value?.constructor?.name === "Object";
    }

    static _cost(value) {
        if (!this._number(value)) {
            return false;
        }

        if (!value || !/^\d+([.,]\d+)?$/.test(value) || parseFloat(value) <= 0) {
            return false;
        }

        return true;
    }

    static _langString(value) {
        if (!this._isObject(value)) {
            return false;
        }

        for (const lang in value) {
            if (!this._string(value[lang])) {
                return false;
            }
        }

        return true;
    }

    static _langNumber(value) {
        if (!this._isObject(value)) {
            return false;
        }

        for (const lang in value) {
            if (!this._number(value[lang])) {
                return false;
            }
        }

        return true;
    }

    static _langInteger(value) {
        if (!this._isObject(value)) {
            return false;
        }

        for (const lang in value) {
            if (!this._integer(value[lang])) {
                return false;
            }
        }

        return true;
    }

    static _langEmail(value) {
        if (!this._isObject(value)) {
            return false;
        }

        for (const lang in value) {
            if (!this._email(value[lang])) {
                return false;
            }
        }

        return true;
    }

    static _string(value) {
        if (!value || typeof value !== "string" || value.trim().length === 0) {
            return false;
        }

        return true;
    }

    static _integer(value) {
        if (!value || isNaN(parseFloat(value)) || parseFloat(value) <= 0) {
            return false;
        } else if (!/^\d([\d\,\.\s]*\d)?$/.test(value)) {
            return false;
        }

        return true;
    }

    static _email(value) {
        return /^[^@]+\@[^@\.]+(\.[^\@\.]+)+$/.test((value || "").trim());
    }

    static _number(value) {
        return /^-?\d+(?:[.,]\d+)?\s*%?$/.test((value || "").toString().trim());
    }

    static _email(value) {
        if (!value || typeof value !== "string" || value.trim().length === 0) {
            return false;
        } else if (!/^[^@]+@[^@.]+(\.[^@.]+)+$/.test(value)) {
            return false;
        }

        return true;
    }
}
